module.exports = __webpack_public_path__ + "543b9b4825f07e09c31919aa1fa6b972.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/super_opgewekt.mp3
// module id = 207
// module chunks = 0